import StickySidebar from 'sticky-sidebar/dist/sticky-sidebar';
import WOW from '../client-admin-app/wow.min'
import $ from "jquery";

let $offset = 120;
if ( $(window).width() < 768) {
    $offset = 70;
} else {
    $offset = 120;
}

$(window).resize(function() {
    if ( $(window).width() < 768) {
        $offset = 70;
    } else {
        $offset = 120;
    }
});

new WOW({
    offset: $offset
}).init();

var apps__sticky_block_1 = new StickySidebar('.apps__sticky-block_1', {
    containerSelector: '#client_app',
    innerWrapperSelector: '.apps__sticky-text',
    topSpacing: 75,
    bottomSpacing: 10,
    stickyClass: 'is-affixed',
});

var apps__sticky_block_2 = new StickySidebar('.apps__sticky-block_2', {
    containerSelector: '#admin_app',
    innerWrapperSelector: '.apps__sticky-text',
    topSpacing: 75,
    bottomSpacing: 10,
    stickyClass: 'is-affixed',
});

